import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/onTimeDeliveryReport'
import Component from 'components/Reports/OnTimeDeliveryReport'

export default createListViewContainer({ actions, selectors: selectors.onTimeDeliveryReport })(Component)
